import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';

// compass: needle shows north; tap = map turns with the phone heading, tap again = north up
const heading = (e) => (e.webkitCompassHeading != null ? e.webkitCompassHeading : e.absolute || e.alpha != null ? (360 - (e.alpha || 0)) % 360 : null);

export default function Compass({ t, getMap }) {
  const [follow, setFollow] = useState(false);
  const [brg, setBrg] = useState(0);
  const last = useRef(0);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    const m = getMap();
    if (!m?.on) { const id = setTimeout(() => setTick((n) => n + 1), 500); return () => clearTimeout(id); }
    const on = () => setBrg(m.getBearing?.() || 0);
    m.on('rotate', on);
    return () => m.off('rotate', on);
  }, [getMap, tick]);
  useEffect(() => {
    if (!follow) return undefined;
    const on = (e) => { const h = heading(e), now = Date.now(); if (h == null || now - last.current < 120) return; last.current = now; getMap()?.setBearing?.(-h); };
    const ev = 'ondeviceorientationabsolute' in window ? 'deviceorientationabsolute' : 'deviceorientation';
    window.addEventListener(ev, on);
    return () => window.removeEventListener(ev, on);
  }, [follow, getMap]);
  const tap = async () => {
    if (follow || brg) { setFollow(false); getMap()?.setBearing?.(0); toast.message(t.cpNorth, { id: 'cp' }); return; }
    try { if (typeof DeviceOrientationEvent?.requestPermission === 'function' && (await DeviceOrientationEvent.requestPermission()) !== 'granted') return; } catch { /* desktop */ }
    setFollow(true); toast.message(t.cpFollow, { id: 'cp' });
  };
  return (
    <button className={`map-compass ${follow ? 'on' : ''}`} data-testid="map-compass-btn" aria-pressed={follow} title={follow ? t.cpNorth : t.cpFollow} onClick={tap}>
      <svg viewBox="0 0 40 40" width="34" height="34" style={{ transform: `rotate(${brg}deg)` }}>
        <circle cx="20" cy="20" r="18" fill="#fff" stroke="#0f172a" strokeWidth="1.5" />
        <path d="M20 5 L25 20 L20 18 L15 20 Z" fill="#dc2626" /><path d="M20 35 L25 20 L20 22 L15 20 Z" fill="#334155" />
        <text x="20" y="13.5" textAnchor="middle" fontSize="6" fontWeight="700" fill="#fff">N</text>
      </svg>
    </button>
  );
}
